import { lazy } from 'react';

export const CataloguePage = lazy(() => import('./CataloguePage'));
